import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export enum RouteConstantEnums {
  ADDENDUM_MANAGEMENT,
}

export const RouteConstantsInterface = {
  ADDENDUM_MANAGEMENT: '/addendum-management',
  ADDENDUM_DETAILS: '/addendum-management/:addendumBatchId',
};

const getAddendumManagementRoute: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.ADDENDUM_MANAGEMENT,
      route: RouteConstantsInterface.ADDENDUM_MANAGEMENT,
      title: ScreenNames.ADDENDUM_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'file-white',
        alt: 'addendum',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.ADDENDUM_MANAGEMENT,
      children: [
        {
          id: ModuleConstants.ADDENDUM_MANAGEMENT,
          route: RouteConstantsInterface.ADDENDUM_DETAILS,
          title: ScreenNames.ADDENDUM_DETAILS,
          component: ComponentsMap.ADDENDUM_DETAILS,
          sidebarVisibility: false,
        },
      ],
    },
  ];
};

export default getAddendumManagementRoute;
